<app-lms-modal-frame [title]="reportTitle" [pageHeadWidth]="600">
  <div modal-body class="p-0">
    <section class="loans-section">

      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <table class="loans-table" #TABLE>
            <caption>
              {{ reportTitle }}
              <span *ngIf="startDate && endDate"> &mdash; {{ startDate }} to {{ endDate }}</span>
            </caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">ID Number</th>
                <th scope="col">Loan Number</th>
                <th scope="col">Created By</th>
                <th scope="col">Job Title</th>
                <th scope="col">Branch Name</th>
                <th scope="col">Area Name</th>
                <th scope="col">Region Name</th>
                <th scope="col">Created Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of scanningMonitoringReportList | paginate: config">
                <td>{{ row.idNumber }}</td>
                <td>{{ row.id }}</td>
                <td>{{ row.createdBy }}</td>
                <td>{{ row.jobTitle }}</td>
                <td>{{ row.branchName }}</td>
                <td>{{ row.areaName }}</td>
                <td>{{ row.regionName }}</td>
                <td>{{ row.createdOn }}</td>
              </tr>
              <tr *ngIf="scanningMonitoringReportList.length === 0">
                <td colspan="10" class="text-center text-muted py-3">No data available.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator-row">
          <pagination-controls [id]="config.id || 'scanning-monitoring-report-pager'"
            (pageChange)="config.currentPage = $event"></pagination-controls>
        </div>
      </div>

      <div class="action-bar">
        <button class="btn-action btn-export" type="button" (click)="exportToExcel()">
          <i class="fas fa-file-excel fa-fw"></i> Export to Excel
        </button>
        <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
      </div>

    </section>
  </div>
</app-lms-modal-frame>
